import './index.scss'

import { useEffect, useRef, useState } from 'react'
import { useAppSelector, useAppDispatch } from '../../store/hook'
import { ResultFull, SendBet } from '../result/type'
import { ASSETS_IMAGE_CACHED } from '../hook/PreloadImage'

import useOrientation from '../hook/Orientation'
import { stopBet } from "../betbar/reducer";
import { selectToOpen } from './reducer'


interface GameIProps {
    dataProps?: null | { payload: ResultFull },
    idx?: number
}

declare global {
    interface Window {
        Phaser: any;
        dragon: any;
        add: any;
        game: any;
        portals: any;
        dataPos: any;
        prizes: any;
        frame: any;
        preload: any;
        SpinePlugin: any;
        PhaserLoaderPlugin: any;
        SpineWebGLPlugin: any
        currPortalLevel: number;
    }
}
let phaserElement: any;
let animating = false
const Game: React.FC<GameIProps> = ({ dataProps, idx } = { dataProps: undefined, idx: -1 }) => {
    const dispatch = useAppDispatch();

    const orientation = useOrientation();

    // const [selectedChest, setSelectedChest] = useState<{ [index: string]: number }>({});
    // const dispatch = useAppDispatch();
    const playerbet = useAppSelector((state) => state.playerbet);
    // // @ts-ignore
    // const ref: {
    //     current: HTMLDivElement
    // } = useRef(null);
    const game = useAppSelector((state) => state.game);
    // const result = useAppSelector((state) => state.result);
    // const history = useAppSelector((state) => state.history);
    // let renderTimeout: any
    // // console.log("rerender game")   

    // useEffect(() => {
    //     setSelectedChest({});
    // }, [playerbet.currMode]);

    // useEffect(() => {
    //     if (!dataProps) {

    //         dispatch(changeSelectChest());
    //         dispatch(selectToOpen(Object.values(selectedChest)));
    //     }

    // }, [selectedChest]);


    // const player = useAppSelector(getPlayer) as Player;
    // const { t, i18n } = useTranslation();
    // const language = i18n.language;
    // const { player_currency } = player;


    // const handleFormatCurrency = (amount: number): string => {
    //     return formatCurrency(amount, player_currency, language);
    // };

    // const handleClick = (e: any) => {
    //     const idxChest: number = Number(e.currentTarget.dataset.idxchest);
    //     if (!idxChest) return;
    //     if (dataProps || (playerbet.currMode == "auto" && playerbet[playerbet.currMode].start)) return;
    //     if (!e.target.className.includes("box")) return;
    //     if (playerbet.currMode == "auto") {
    //         setSelectedChest((old: any) => {
    //             let newSelected;
    //             if (!Object.values(old).includes(idxChest)) {
    //                 // if (Object.keys(old).length == (25 - playerbet.auto.mines))
    //                     // return old;
    //                 newSelected = ({ ...old, [Object.keys(old).length]: idxChest });
    //             }
    //             else {
    //                 newSelected = ({ ...Object.values(old).filter((idxSelected) => idxSelected != idxChest), });
    //             }
    //             return newSelected;
    //         });
    //         return;
    //     } else {

    //         if (!e.currentTarget.querySelector('.content') && !game.isOpenBomb && playerbet[playerbet.currMode].start) {

    //             // if (game.openCount == (25 - playerbet.manual.mines))
    //             //     return;

    //             const sendBet: SendBet = {
    //                 game: "GH000001",
    //                 total_amount: playerbet[playerbet.currMode].amount,
    //                 button_bet: {
    //                     amount: playerbet[playerbet.currMode].amount,
    //                     difficulty: playerbet[playerbet.currMode].difficulty,
    //                     path: idxChest + "",
    //                     round_id: history.current_round,
    //                     state: "sweep"
    //                 },
    //                 round_id: history.current_round
    //             };
    //             if (result.payload.last_bet.button_bet.state == "sweep" && result.payload.last_bet.button_bet.path == idxChest + "") {

    //             } else {

    //                 if (result.status !== "loading")
    //                     dispatch(sendBetAction(sendBet));
    //             }
    //         }
    //     }
    // }

    useEffect(() => {
        if (document.getElementById('phaser')) {
            //    console.log("console remove", document.getElementById('phaser'))

            phaserElement = document.getElementById('phaser');
        }

        if ((phaserElement)) {

            console.log("console add", phaserElement);
            (document.querySelector('.game-container.main')!.firstChild as HTMLElement).appendChild(phaserElement)
            // return ()=>{
            //     if(document.getElementById('phaser')){
            //    console.log("console remove", document.getElementById('phaser'))

            //      phaserElement = document.getElementById('phaser');
            //     }
            //     (ref.current.firstChild as HTMLElement).removeChild(phaserElement)
            // }
        }
    }, [])

    useEffect(() => {
        if (window.dragon) {
            if (orientation == "portrait") {

                window.dragon.setY(460)
                window.dragon.setX(510)
            } else {
                window.dragon.setY(530)
                window.dragon.setX(450)
            }
        }
    }, [orientation, window.dragon])

    useEffect(() => {
        if (window.frame) {
            if (orientation == "portrait") {

                window.frame.setY(730)
                window.frame.setX(530)
                window.frame.setScale(1.6);

            } else {
                window.frame.setY(587)
                window.frame.setX(483)
                window.frame.setScale(1);
            }
        }
    }, [orientation, window.frame])


    useEffect(() => {

        if (playerbet.currMode == "manual") {

            if (window.portals[orientation] && window.portals[orientation][playerbet[playerbet.currMode].difficulty]) {

                requestAnimationFrame(() => {


                    const handleClick = (e: any, portalLevel: number) => {

                        const handleOnClick = () => {
                            console.log(e, portalLevel);
                            if (animating || !window.currPortalLevel || portalLevel != window.currPortalLevel || !playerbet[playerbet.currMode].start) return;

                            const array: any = ['open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-win-', 'open-lose-', 'open-lose-', 'open-lose-', 'open-lose-'];
                            const difficultyToAnime: any = {
                                'easy': 'easy',
                                'medium': 'normal',
                                'hard': 'hard',
                                'expert': 'expert',
                                'master': 'master',
                            }
                            const newPortalTexture = array[Math.floor(Math.random() * array.length)].concat(playerbet[playerbet.currMode].difficulty);
                            e.setTexture(newPortalTexture);
                            if (newPortalTexture.includes("lose")) {
                                animating = true;
                                window.dragon.setAnimation(0, 'lose', false);
                                setTimeout(() => {
                                    window.dragon.setAnimation(0, 'idle', true);
                                    window.currPortalLevel = 0;
                                    const currPortal = [...window.portals[orientation][playerbet[playerbet.currMode].difficulty]].reverse();
                                    chunkArray(currPortal, window.dataPos[orientation][playerbet[playerbet.currMode].difficulty].col).map((chunk, idx) => {

                                        chunk.map((i: any) => i.setAlpha(0.3))
                                        if (idx + 1 <= window.currPortalLevel) {
                                            chunk.map((i: any) => {
                                                i.setAlpha(1);
                                    
                                            })
                                        }
                                    });
                                    animating = false;
                                    dispatch(stopBet());
                                }, window.dragon.state.tracks[window.dragon.state.tracks.length - 1].animation.duration * 1000);
                                window.prizes.push(window.add.spine(e.x, e.y - 40, 'skull', ''.concat(difficultyToAnime[playerbet[playerbet.currMode].difficulty]), false));
                                window.prizes[window.prizes.length-1].setScale(window.dataPos[orientation][playerbet[playerbet.currMode].difficulty].scale||1);
                            }
                            if (newPortalTexture.includes("win")) {
                                animating = true;
                                window.dragon.setAnimation(0, 'win', false);
                                setTimeout(() => {

                                    window.dragon.setAnimation(0, 'idle', true);
                                    window.currPortalLevel = window.currPortalLevel + 1;
                                    const currPortal = [...window.portals[orientation][playerbet[playerbet.currMode].difficulty]].reverse();
                                    chunkArray(currPortal, window.dataPos[orientation][playerbet[playerbet.currMode].difficulty].col).map((chunk, idx) => {

                                        chunk.map((i: any) => i.setAlpha(0.3))
                                        if (idx + 1 <= window.currPortalLevel) {
                                            chunk.map((i: any) => {
                                                i.setAlpha(1);
                                            })
                                        }
                                    });
                                    if (window.currPortalLevel-1 == 9)
                                        dispatch(stopBet());
                                    animating = false;


                                }, window.dragon.state.tracks[window.dragon.state.tracks.length - 1].animation.duration * 1000);
                                window.prizes.push(window.add.spine(e.x, e.y, 'egg', 'egg '.concat(difficultyToAnime[playerbet[playerbet.currMode].difficulty]), false));
                                window.prizes[window.prizes.length-1].setScale(window.dataPos[orientation][playerbet[playerbet.currMode].difficulty].scale||1);
                            }

                        }

                        return handleOnClick;
                    }
                    const difficultyData = ["easy", "medium", "hard", "expert", "master"];
                    const orientationData = ["landscape", "portrait"];
                    orientationData.map((mode) => {

                        difficultyData.map((level) => {

                            window.prizes.map((prize: any) => {
                                prize.destroy();
                                

                            });
                            window.prizes =[];
                            window.portals[mode][level].map((portal: any) => {
                                setTimeout(() => {
                                    portal.removeAllListeners();
                                    portal.setTexture(window.dataPos[mode][level].imgName);
                                    window.game.scene.getAt(0).tweens.add({
                                        targets: portal,
                                        scaleX: 0,
                                        scaleY: 0,
                                        alpha: 0,
                                        onComplete: () => {
                                        }
                                    });

                                }, 0);
                            });
                        });
                    });


                    setTimeout(() => {
                        const row = 9;
                        let portalLevel = row;
                        window.portals[orientation][playerbet[playerbet.currMode].difficulty].map((portal: any, idx: number) => {
                            window.portals[orientation][playerbet[playerbet.currMode].difficulty][idx].handleClick = handleClick(portal, portalLevel);
                            portal.removeAllListeners();
                            window.game.scene.getAt(0).tweens.add({
                                targets: portal,
                                scaleX: window.dataPos[orientation][playerbet[playerbet.currMode].difficulty].scale || 1,
                                scaleY: window.dataPos[orientation][playerbet[playerbet.currMode].difficulty].scale || 1,
                                alpha: 1,
                                onComplete: () => {
                                    portal.on('pointerdown', window.portals[orientation][playerbet[playerbet.currMode].difficulty][idx].handleClick);
                                    if (playerbet[playerbet.currMode].start && idx == window.portals[orientation][playerbet[playerbet.currMode].difficulty].length - 1) {
                                        const currPortal = [...window.portals[orientation][playerbet[playerbet.currMode].difficulty]].reverse();
                                        chunkArray(currPortal, window.dataPos[orientation][playerbet[playerbet.currMode].difficulty].col).map((chunk, idx) => {

                                            chunk.map((i: any) => i.setAlpha(0.3))
                                            if (idx + 1 <= window.currPortalLevel) {
                                                chunk.map((i: any) => {
                                                    i.setAlpha(1);
                                                })
                                            }
                                        });
                                    }
                                }
                            });

                            if ((idx + 1) % window.dataPos[orientation][playerbet[playerbet.currMode].difficulty].col == 0) {
                                portalLevel = portalLevel - 1;
                            }
                        });
                    }, 0);

                });

                return () => {
                }
            }
        }

    }, [orientation, window.portals[orientation] && window.portals[orientation][playerbet[playerbet.currMode].difficulty], playerbet[playerbet.currMode].difficulty, playerbet[playerbet.currMode].start, playerbet.currMode]);



    useEffect(() => {

        if (playerbet.currMode == "auto") {

            if (window.portals[orientation] && window.portals[orientation][playerbet[playerbet.currMode].difficulty]) {

                requestAnimationFrame(() => {


                    const handleClick = (e: any, portalLevel: number, idx: number) => {

                        const handleOnClick = () => {
                            console.log(e, portalLevel);
                            if (playerbet[playerbet.currMode].start) return;
                            if (window.currPortalLevel < portalLevel) return;
                            if (e._alpha == 0.3) {
                                e.setAlpha(1);
                                const currPortal = [...window.portals[orientation][playerbet[playerbet.currMode].difficulty]].reverse();
                            chunkArray(currPortal, window.dataPos[orientation][playerbet[playerbet.currMode].difficulty].col).map((chunk, idx) => {

                                if (idx + 1 >portalLevel) {
                                    chunk.map((i: any) => {
                                        i.setAlpha(1)
                                    });
                                }
                            });
                                window.currPortalLevel = portalLevel;
                                const currPortal2 = [...window.portals[orientation][playerbet[playerbet.currMode].difficulty]].reverse();

                                dispatch(selectToOpen(currPortal2.filter((i)=>i._alpha==0.3).map((_,idx)=>idx)));
                                return;
                            }
                            const currPortal = [...window.portals[orientation][playerbet[playerbet.currMode].difficulty]].reverse();
                            chunkArray(currPortal, window.dataPos[orientation][playerbet[playerbet.currMode].difficulty].col).map((chunk, idx) => {

                                if (idx + 1 == portalLevel) {
                                    chunk.map((i: any) => {
                                        i.setAlpha(1)
                                    });
                                }
                            });
                            e.setAlpha(0.3);
                            window.currPortalLevel = portalLevel + 1;
                            const currPortal2 = [...window.portals[orientation][playerbet[playerbet.currMode].difficulty]].reverse();

                            dispatch(selectToOpen(currPortal2.filter((i)=>i._alpha==0.3).map((_,idx)=>idx)));
                        }

                        return handleOnClick;
                    }
                    const difficultyData = ["easy", "medium", "hard", "expert", "master"];
                    const orientationData = ["landscape", "portrait"];
                    orientationData.map((mode) => {

                        difficultyData.map((level) => {

                            window.prizes.map((prize: any) => {
                                prize.destroy();
                            });
                            window.prizes=[];
                            window.portals[mode][level].map((portal: any) => {
                                setTimeout(() => {
                                    portal.removeAllListeners();
                                    portal.setTexture(window.dataPos[mode][level].imgName);
                                    window.game.scene.getAt(0).tweens.add({
                                        targets: portal,
                                        scaleX: 0,
                                        scaleY: 0,
                                        alpha: 0,
                                        onComplete: () => {
                                        }
                                    });

                                }, 0);
                            });
                        });
                    });


                    setTimeout(() => {
                        const row = 9;
                        let portalLevel = row;
                        window.currPortalLevel = 1;
                        window.portals[orientation][playerbet[playerbet.currMode].difficulty].map((portal: any, idx: number) => {
                            window.portals[orientation][playerbet[playerbet.currMode].difficulty][idx].handleClick = handleClick(portal, portalLevel, idx);
                            portal.removeAllListeners();
                            window.game.scene.getAt(0).tweens.add({
                                targets: portal,
                                scaleX: window.dataPos[orientation][playerbet[playerbet.currMode].difficulty].scale || 1,
                                scaleY: window.dataPos[orientation][playerbet[playerbet.currMode].difficulty].scale || 1,
                                alpha: 1,
                                onComplete: () => {
                                    portal.on('pointerdown', window.portals[orientation][playerbet[playerbet.currMode].difficulty][idx].handleClick);
                                }
                            });

                            if ((idx + 1) % window.dataPos[orientation][playerbet[playerbet.currMode].difficulty].col == 0) {
                                portalLevel = portalLevel - 1;
                            }
                        });
                    }, 0);

                });

                return () => {
                }
            }
        }

    }, [orientation, window.portals[orientation] && window.portals[orientation][playerbet[playerbet.currMode].difficulty], playerbet[playerbet.currMode].difficulty, playerbet[playerbet.currMode].start, playerbet.currMode]);



    useEffect(() => {
        if (orientation && window.prizes) {

            requestAnimationFrame(() => {

                const difficultyData = ["easy", "medium", "hard", "expert", "master"];
                const orientationData = ["landscape", "portrait"];
                orientationData.map((mode) => {

                    difficultyData.map((level) => {

                        // window.prizes.map((prize: any) => {
                        //     prize.destroy();
                        // });
                    });
                });


            });

            return () => {

            }
        }

    }, [orientation, window.prizes]);


    return <div className={"game-container ".concat(`${dataProps ? "game-history-table" : "main ".concat(playerbet[playerbet.currMode].difficulty)}`)}>
        <div className="game-wrapper">

            {/* <PhaserComponent /> */}

            {/* <div className={"portal-container"}>
                {
                    Array.from(Array(9).keys()).map((idxRow) => {
                        return <div key={`${dataProps ? "history" : "main"}-row-${idxRow}-${""}`} className="row">
                            {
                                Array.from(Array(portalsDifficult[playerbet[playerbet.currMode].difficulty]).keys()).map((idxCol) => {
                                    const idxChest = idxRow * portalsDifficult[playerbet[playerbet.currMode].difficulty] + idxCol + 1;

                                    return <Chest key={`${dataProps ? "history" : "main"}-col-box-${idxChest}`}  {...{ idxChest, dataProps, handleClick, selected: game.selected.includes(idxChest), idxRow }} />
                                })
                            }

                        </div>
                    })
                }
            </div> */}

        </div>
        {
            // (playerbet.currMode == "auto" && result.status == "succeeded" && result.payload && result.payload.prize)
            //     || (playerbet.currMode == "manual" && result.status == "succeeded" && result.payload.last_bet.button_bet.state == "cashout") ?

            //     <div className='total-profit-auto'>
            //         <img onContextMenu={(e) => e.preventDefault()} draggable="false" className='bg-prize' src={TotalPrize} alt="" />
            //         <span>
            //             Total Win

            //             <br />
            //             {handleFormatCurrency(result.payload.prize * result.payload.last_bet.total_amount)}
            //         </span>
            //     </div>
            //     : <></>
        }


    </div>;
}

export default Game;


export const images = {
    // Diamond1, Diamond2, Diamond3, Diamond4, Diamond5
}

export const randomProperty: (T: typeof images) => keyof typeof images = (obj) => {
    const keys = Object.keys(obj);
    return (keys[keys.length * Math.random() << 0]) as keyof typeof images;
};
export const cachedDataImage = (url: any) => {

    return new Promise<string>(async (callback) => {
        // if (document.querySelector('.safari.iPhone'))
        return callback(url);

        caches.open(ASSETS_IMAGE_CACHED).then(cache => {
            cache.match(url).then(async (data) => {
                if (!data) return callback(url);
                let reader = new FileReader();
                reader.onload = function () { callback(this.result as string) };
                reader.readAsDataURL(await data!.blob());
            });
        });
    })
}

function chunkArray(array: any[], size: number) {
    const chunkedArray = [];
    let index = 0;

    while (index < array.length) {
        chunkedArray.push(array.slice(index, index + size));
        index += size;
    }

    return chunkedArray;
}


